import { DelimitedTextDataset } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { FormatTypeCopySource } from './format-type.copysource';

@Metamodel.model({
    name: 'DelimitedTextSource',
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(DelimitedTextDataset)]}
})
export class DelimitedTextCopySource extends FormatTypeCopySource {
}
